export const sumRanges = {
  loans: [
    { label: '0', min: 0, max: 0 },
    { label: '1-50000', min: 1, max: 50000 },
    { label: '50001-100000', min: 50001, max: 100000 },
    { label: '100001-150000', min: 100001, max: 150000 },
    { label: '150001-200000', min: 150001, max: 200000 },
    { label: '200001-250000', min: 200001, max: 250000 },
    { label: '250001-300000', min: 250001, max: 300000 },
    { label: '300001-350000', min: 300001, max: 350000 },
    { label: '350001-400000', min: 350001, max: 400000 },
    { label: '400001-450000', min: 400001, max: 450000 },
    { label: '450001-500000', min: 450001, max: 500000 },
    { label: '500001-9999999', min: 500001, max: 9999999 },
  ],
  unsecuredloans: [
    { label: '0', min: 0, max: 0 },
    { label: '1-5000', min: 1, max: 5000 },
    { label: '5001-10000', min: 5001, max: 10000 },
    { label: '10001-15000', min: 10001, max: 15000 },
    { label: '15001-20000', min: 15001, max: 20000 },
    { label: '20001-25000', min: 20001, max: 25000 },
    { label: '25001-30000', min: 25001, max: 30000 },
    { label: '30001-35000', min: 30001, max: 35000 },
    { label: '35001-40000', min: 35001, max: 40000 },
    { label: '45001-50000', min: 45001, max: 50000 },
    { label: '50001-9999999', min: 50001, max: 9999999 },
  ],
  investments: [
    { label: '0', min: 0, max: 0 },
    { label: '1-5000', min: 1, max: 5000 },
    { label: '5001-10000', min: 5001, max: 10000 },
    { label: '10001-20000', min: 10001, max: 20000 },
    { label: '20001-30000', min: 20001, max: 30000 },
    { label: '30001-40000', min: 30001, max: 40000 },
    { label: '40001-50000', min: 40001, max: 50000 },
    { label: '50001-60000', min: 50001, max: 60000 },
    { label: '60001-70000', min: 60001, max: 70000 },
    { label: '70001-80000', min: 70001, max: 80000 },
    { label: '80001-90000', min: 80001, max: 90000 },
    { label: '90001-100000', min: 90001, max: 100000 },
    { label: '100001-9999999', min: 100001, max: 9999999 },
  ],
  savings: [
    { label: '0', min: 0, max: 0 },
    { label: '1-5000', min: 1, max: 5000 },
    { label: '5001-10000', min: 5001, max: 10000 },
    { label: '10001-20000', min: 10001, max: 20000 },
    { label: '20001-30000', min: 20001, max: 30000 },
    { label: '30001-40000', min: 30001, max: 40000 },
    { label: '40001-50000', min: 40001, max: 50000 },
    { label: '50001-60000', min: 50001, max: 60000 },
    { label: '60001-70000', min: 60001, max: 70000 },
    { label: '70001-80000', min: 70001, max: 80000 },
    { label: '80001-90000', min: 80001, max: 90000 },
    { label: '90001-100000', min: 90001, max: 100000 },
    { label: '100001-9999999', min: 100001, max: 9999999 },
  ],
  premiums: [
    { label: '0', min: 0, max: 0 },
    { label: '1-500', min: 1, max: 500 },
    { label: '501-1000', min: 501, max: 1000 },
    { label: '1001-1500', min: 1001, max: 1500 },
    { label: '1501-2000', min: 1501, max: 2000 },
    { label: '2001-2500', min: 2001, max: 2500 },
    { label: '2501-3000', min: 2501, max: 3000 },
    { label: '3001-3500', min: 3001, max: 3500 },
    { label: '3501-4000', min: 3501, max: 4000 },
    { label: '4001-4500', min: 4001, max: 4500 },
    { label: '4501-5000', min: 4501, max: 5000 },
    { label: '5001-10000', min: 5001, max: 10000 },
    { label: '10001-9999999', min: 10001, max: 9999999 },
  ],
  estimatedbonuses: [
    { label: '0-10,00', min: 0, max: 10.00 },
    { label: '10,01-50,00', min: 10.01, max: 50.00 },
    { label: '50,01-100,00', min: 50.01, max: 100.00 },
    { label: '100,01-200,00', min: 100.01, max: 200.00 },
    { label: '200,01-300,00', min: 200.01, max: 300.00 },
    { label: '300,01-400,00', min: 300.01, max: 400.00 },
    { label: '400,01-500,00', min: 400.01, max: 500.00 },
    { label: '500,01-600,00', min: 500.01, max: 600.00 },
    { label: '600,01-700,00', min: 600.01, max: 700.00 },
    { label: '700,01-800,00', min: 700.01, max: 800.00 },
    { label: '800,01-900,00', min: 800.01, max: 900.00 },
    { label: '900,01-1000,00', min: 900.01, max: 1000.00 },
    { label: '1000,01-5000,00', min: 1000.01, max: 5000.00 },
    { label: '5000,01-10000,00', min: 5000.01, max: 10000.00 },
    { label: '10000,01-999999,99', min: 10000.01, max: 999999.99 },
  ],
};